export default __webpack_public_path__ + "static/media/01.c2a5ad01.jpg";